import { useState, useCallback } from 'react';

export interface UseSelectionModeReturn {
  enabled: boolean;
  selected: Set<string>;
  enter: () => void;
  exit: () => void;
  toggle: (id: number | string) => void;
  setAll: (ids: (number | string)[]) => void;
  clear: () => void;
}

export function useSelectionMode(): UseSelectionModeReturn {
  const [enabled, setEnabled] = useState(false);
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const enter = useCallback(() => setEnabled(true), []);

  const exit = useCallback(() => {
    setEnabled(false);
    setSelected(new Set());
  }, []);

  const toggle = useCallback((id: number | string) => {
    const key = String(id);
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  }, []);

  const setAll = useCallback(
    (ids: (number | string)[]) => setSelected(new Set(ids.map(String))),
    []
  );

  const clear = useCallback(() => setSelected(new Set()), []);

  return { enabled, selected, enter, exit, toggle, setAll, clear };
}
